module.exports = __webpack_public_path__ + "static/img/thermometre-mobile.7cf0e43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thermometre-mobile.png
// module id = 1H57
// module chunks = 1